export enum OverFlowTypes {
    HIDDEN = 'hidden',
    AUTO = 'auto',
    SCROLL = 'scroll',
    VISIBLE = 'visible',
}

export enum DSClassNames {
    DSScrollbar = 'ds-scrollbar',
    DSScrollbarInverse = 'ds-scrollbar-inverse',
}

export enum FeatureNames {
    EGV = 'egv',
    SLOTS = 'slots',
    SEARCHCANCEL = 'searchcancel',
}
